/*
 * @Author: Veto [关于活动部分 路由]
 * @Date: 2023-10-09 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 */

import ShareTianmi from '../views/share/tianmi';


const router = {
    '/share-admin-1': ShareTianmi,
    '/share-admin-2': ShareTianmi,
    '/share-admin-3': ShareTianmi,
    '/share-admin-4': ShareTianmi,
    '/share-admin-5': ShareTianmi,
    '/share-admin-6': ShareTianmi,
    '/share-admin-7': ShareTianmi,
    '/share-admin-8': ShareTianmi,
    '/share-admin-9': ShareTianmi,
    '/share-admin-10': ShareTianmi,

    '/share-admin-11': ShareTianmi,
    '/share-admin-12': ShareTianmi,
    '/share-admin-13': ShareTianmi,
    '/share-admin-14': ShareTianmi,
    '/share-admin-15': ShareTianmi,
    '/share-admin-16': ShareTianmi,
    '/share-admin-17': ShareTianmi,
    '/share-admin-18': ShareTianmi,
    '/share-admin-19': ShareTianmi,
    '/share-admin-20': ShareTianmi,

    '/share-admin-21': ShareTianmi,
    '/share-admin-22': ShareTianmi,
    '/share-admin-23': ShareTianmi,
    '/share-admin-24': ShareTianmi,
    '/share-admin-25': ShareTianmi,
    '/share-admin-26': ShareTianmi,
    '/share-admin-27': ShareTianmi,
    '/share-admin-28': ShareTianmi,
    '/share-admin-29': ShareTianmi,
    '/share-admin-30': ShareTianmi,

    '/share-admin-31': ShareTianmi,
    '/share-admin-32': ShareTianmi,
    '/share-admin-33': ShareTianmi,
    '/share-admin-34': ShareTianmi,
    '/share-admin-35': ShareTianmi,
    '/share-admin-36': ShareTianmi,
    '/share-admin-37': ShareTianmi,
    '/share-admin-38': ShareTianmi,
    '/share-admin-39': ShareTianmi,
    '/share-admin-40': ShareTianmi,

    '/share-admin-41': ShareTianmi,
    '/share-admin-42': ShareTianmi,
    '/share-admin-43': ShareTianmi,
    '/share-admin-44': ShareTianmi,
    '/share-admin-45': ShareTianmi,
    '/share-admin-46': ShareTianmi,
    '/share-admin-47': ShareTianmi,
    '/share-admin-48': ShareTianmi,
    '/share-admin-49': ShareTianmi,
    '/share-admin-50': ShareTianmi,












    '/share-second-1': ShareTianmi,
    '/share-second-2': ShareTianmi,
    '/share-second-3': ShareTianmi,
    '/share-second-4': ShareTianmi,
    '/share-second-5': ShareTianmi,
    '/share-second-6': ShareTianmi,
    '/share-second-7': ShareTianmi,
    '/share-second-8': ShareTianmi,
    '/share-second-9': ShareTianmi,
    '/share-second-10': ShareTianmi,

    '/share-second-11': ShareTianmi,
    '/share-second-12': ShareTianmi,
    '/share-second-13': ShareTianmi,
    '/share-second-14': ShareTianmi,
    '/share-second-15': ShareTianmi,
    '/share-second-16': ShareTianmi,
    '/share-second-17': ShareTianmi,
    '/share-second-18': ShareTianmi,
    '/share-second-19': ShareTianmi,
    '/share-second-20': ShareTianmi,

    '/share-second-21': ShareTianmi,
    '/share-second-22': ShareTianmi,
    '/share-second-23': ShareTianmi,
    '/share-second-24': ShareTianmi,
    '/share-second-25': ShareTianmi,
    '/share-second-26': ShareTianmi,
    '/share-second-27': ShareTianmi,
    '/share-second-28': ShareTianmi,
    '/share-second-29': ShareTianmi,
    '/share-second-30': ShareTianmi,

    '/share-second-31': ShareTianmi,
    '/share-second-32': ShareTianmi,
    '/share-second-33': ShareTianmi,
    '/share-second-34': ShareTianmi,
    '/share-second-35': ShareTianmi,
    '/share-second-36': ShareTianmi,
    '/share-second-37': ShareTianmi,
    '/share-second-38': ShareTianmi,
    '/share-second-39': ShareTianmi,
    '/share-second-40': ShareTianmi,

    '/share-second-41': ShareTianmi,
    '/share-second-42': ShareTianmi,
    '/share-second-43': ShareTianmi,
    '/share-second-44': ShareTianmi,
    '/share-second-45': ShareTianmi,
    '/share-second-46': ShareTianmi,
    '/share-second-47': ShareTianmi,
    '/share-second-48': ShareTianmi,
    '/share-second-49': ShareTianmi,
    '/share-second-50': ShareTianmi,

    '/share-second-51': ShareTianmi,
    '/share-second-52': ShareTianmi,
    '/share-second-53': ShareTianmi,
    '/share-second-54': ShareTianmi,
    '/share-second-55': ShareTianmi,
    '/share-second-56': ShareTianmi,
    '/share-second-57': ShareTianmi,
    '/share-second-58': ShareTianmi,
    '/share-second-59': ShareTianmi,
    '/share-second-60': ShareTianmi,

    '/share-second-61': ShareTianmi,
    '/share-second-62': ShareTianmi,
    '/share-second-63': ShareTianmi,
    '/share-second-64': ShareTianmi,
    '/share-second-65': ShareTianmi,
    '/share-second-66': ShareTianmi,
    '/share-second-67': ShareTianmi,
    '/share-second-68': ShareTianmi,
    '/share-second-69': ShareTianmi,
    '/share-second-70': ShareTianmi,

    '/share-second-71': ShareTianmi,
    '/share-second-72': ShareTianmi,
    '/share-second-73': ShareTianmi,
    '/share-second-74': ShareTianmi,
    '/share-second-75': ShareTianmi,
    '/share-second-76': ShareTianmi,
    '/share-second-77': ShareTianmi,
    '/share-second-78': ShareTianmi,
    '/share-second-79': ShareTianmi,
    '/share-second-80': ShareTianmi,

    '/share-second-81': ShareTianmi,
    '/share-second-82': ShareTianmi,
    '/share-second-83': ShareTianmi,
    '/share-second-84': ShareTianmi,
    '/share-second-85': ShareTianmi,
    '/share-second-86': ShareTianmi,
    '/share-second-87': ShareTianmi,
    '/share-second-88': ShareTianmi,
    '/share-second-89': ShareTianmi,
    '/share-second-90': ShareTianmi,

    '/share-second-91': ShareTianmi,
    '/share-second-92': ShareTianmi,
    '/share-second-93': ShareTianmi,
    '/share-second-94': ShareTianmi,
    '/share-second-95': ShareTianmi,
    '/share-second-96': ShareTianmi,
    '/share-second-97': ShareTianmi,
    '/share-second-98': ShareTianmi,
    '/share-second-99': ShareTianmi,
    '/share-second-100': ShareTianmi,


    // 100 - 200
    '/share-second-101': ShareTianmi,
    '/share-second-102': ShareTianmi,
    '/share-second-103': ShareTianmi,
    '/share-second-104': ShareTianmi,
    '/share-second-105': ShareTianmi,
    '/share-second-106': ShareTianmi,
    '/share-second-107': ShareTianmi,
    '/share-second-108': ShareTianmi,
    '/share-second-109': ShareTianmi,
    '/share-second-110': ShareTianmi,

    '/share-second-111': ShareTianmi,
    '/share-second-112': ShareTianmi,
    '/share-second-113': ShareTianmi,
    '/share-second-114': ShareTianmi,
    '/share-second-115': ShareTianmi,
    '/share-second-116': ShareTianmi,
    '/share-second-117': ShareTianmi,
    '/share-second-118': ShareTianmi,
    '/share-second-119': ShareTianmi,
    '/share-second-120': ShareTianmi,

    '/share-second-121': ShareTianmi,
    '/share-second-122': ShareTianmi,
    '/share-second-123': ShareTianmi,
    '/share-second-124': ShareTianmi,
    '/share-second-125': ShareTianmi,
    '/share-second-126': ShareTianmi,
    '/share-second-127': ShareTianmi,
    '/share-second-128': ShareTianmi,
    '/share-second-129': ShareTianmi,
    '/share-second-130': ShareTianmi,

    '/share-second-131': ShareTianmi,
    '/share-second-132': ShareTianmi,
    '/share-second-133': ShareTianmi,
    '/share-second-134': ShareTianmi,
    '/share-second-135': ShareTianmi,
    '/share-second-136': ShareTianmi,
    '/share-second-137': ShareTianmi,
    '/share-second-138': ShareTianmi,
    '/share-second-139': ShareTianmi,
    '/share-second-140': ShareTianmi,

    '/share-second-141': ShareTianmi,
    '/share-second-142': ShareTianmi,
    '/share-second-143': ShareTianmi,
    '/share-second-144': ShareTianmi,
    '/share-second-145': ShareTianmi,
    '/share-second-146': ShareTianmi,
    '/share-second-147': ShareTianmi,
    '/share-second-148': ShareTianmi,
    '/share-second-149': ShareTianmi,
    '/share-second-150': ShareTianmi,

    '/share-second-151': ShareTianmi,
    '/share-second-152': ShareTianmi,
    '/share-second-153': ShareTianmi,
    '/share-second-154': ShareTianmi,
    '/share-second-155': ShareTianmi,
    '/share-second-156': ShareTianmi,
    '/share-second-157': ShareTianmi,
    '/share-second-158': ShareTianmi,
    '/share-second-159': ShareTianmi,
    '/share-second-160': ShareTianmi,

    '/share-second-161': ShareTianmi,
    '/share-second-162': ShareTianmi,
    '/share-second-163': ShareTianmi,
    '/share-second-164': ShareTianmi,
    '/share-second-165': ShareTianmi,
    '/share-second-166': ShareTianmi,
    '/share-second-167': ShareTianmi,
    '/share-second-168': ShareTianmi,
    '/share-second-169': ShareTianmi,
    '/share-second-170': ShareTianmi,

    '/share-second-171': ShareTianmi,
    '/share-second-172': ShareTianmi,
    '/share-second-173': ShareTianmi,
    '/share-second-174': ShareTianmi,
    '/share-second-175': ShareTianmi,
    '/share-second-176': ShareTianmi,
    '/share-second-177': ShareTianmi,
    '/share-second-178': ShareTianmi,
    '/share-second-179': ShareTianmi,
    '/share-second-180': ShareTianmi,

    '/share-second-181': ShareTianmi,
    '/share-second-182': ShareTianmi,
    '/share-second-183': ShareTianmi,
    '/share-second-184': ShareTianmi,
    '/share-second-185': ShareTianmi,
    '/share-second-186': ShareTianmi,
    '/share-second-187': ShareTianmi,
    '/share-second-188': ShareTianmi,
    '/share-second-189': ShareTianmi,
    '/share-second-190': ShareTianmi,

    '/share-second-191': ShareTianmi,
    '/share-second-192': ShareTianmi,
    '/share-second-193': ShareTianmi,
    '/share-second-194': ShareTianmi,
    '/share-second-195': ShareTianmi,
    '/share-second-196': ShareTianmi,
    '/share-second-197': ShareTianmi,
    '/share-second-198': ShareTianmi,
    '/share-second-199': ShareTianmi,
    '/share-second-200': ShareTianmi,


    // 200-300
    '/share-second-201': ShareTianmi,
    '/share-second-202': ShareTianmi,
    '/share-second-203': ShareTianmi,
    '/share-second-204': ShareTianmi,
    '/share-second-205': ShareTianmi,
    '/share-second-206': ShareTianmi,
    '/share-second-207': ShareTianmi,
    '/share-second-208': ShareTianmi,
    '/share-second-209': ShareTianmi,
    '/share-second-210': ShareTianmi,

    '/share-second-211': ShareTianmi,
    '/share-second-212': ShareTianmi,
    '/share-second-213': ShareTianmi,
    '/share-second-214': ShareTianmi,
    '/share-second-215': ShareTianmi,
    '/share-second-216': ShareTianmi,
    '/share-second-217': ShareTianmi,
    '/share-second-218': ShareTianmi,
    '/share-second-219': ShareTianmi,
    '/share-second-220': ShareTianmi,

    '/share-second-221': ShareTianmi,
    '/share-second-222': ShareTianmi,
    '/share-second-223': ShareTianmi,
    '/share-second-224': ShareTianmi,
    '/share-second-225': ShareTianmi,
    '/share-second-226': ShareTianmi,
    '/share-second-227': ShareTianmi,
    '/share-second-228': ShareTianmi,
    '/share-second-229': ShareTianmi,
    '/share-second-230': ShareTianmi,

    '/share-second-231': ShareTianmi,
    '/share-second-232': ShareTianmi,
    '/share-second-233': ShareTianmi,
    '/share-second-234': ShareTianmi,
    '/share-second-235': ShareTianmi,
    '/share-second-236': ShareTianmi,
    '/share-second-237': ShareTianmi,
    '/share-second-238': ShareTianmi,
    '/share-second-239': ShareTianmi,
    '/share-second-240': ShareTianmi,

    '/share-second-241': ShareTianmi,
    '/share-second-242': ShareTianmi,
    '/share-second-243': ShareTianmi,
    '/share-second-244': ShareTianmi,
    '/share-second-245': ShareTianmi,
    '/share-second-246': ShareTianmi,
    '/share-second-247': ShareTianmi,
    '/share-second-248': ShareTianmi,
    '/share-second-249': ShareTianmi,
    '/share-second-250': ShareTianmi,

    '/share-second-251': ShareTianmi,
    '/share-second-252': ShareTianmi,
    '/share-second-253': ShareTianmi,
    '/share-second-254': ShareTianmi,
    '/share-second-255': ShareTianmi,
    '/share-second-256': ShareTianmi,
    '/share-second-257': ShareTianmi,
    '/share-second-258': ShareTianmi,
    '/share-second-259': ShareTianmi,
    '/share-second-260': ShareTianmi,

    '/share-second-261': ShareTianmi,
    '/share-second-262': ShareTianmi,
    '/share-second-263': ShareTianmi,
    '/share-second-264': ShareTianmi,
    '/share-second-265': ShareTianmi,
    '/share-second-266': ShareTianmi,
    '/share-second-267': ShareTianmi,
    '/share-second-268': ShareTianmi,
    '/share-second-269': ShareTianmi,
    '/share-second-270': ShareTianmi,

    '/share-second-271': ShareTianmi,
    '/share-second-272': ShareTianmi,
    '/share-second-273': ShareTianmi,
    '/share-second-274': ShareTianmi,
    '/share-second-275': ShareTianmi,
    '/share-second-276': ShareTianmi,
    '/share-second-277': ShareTianmi,
    '/share-second-278': ShareTianmi,
    '/share-second-279': ShareTianmi,
    '/share-second-280': ShareTianmi,

    '/share-second-281': ShareTianmi,
    '/share-second-282': ShareTianmi,
    '/share-second-283': ShareTianmi,
    '/share-second-284': ShareTianmi,
    '/share-second-285': ShareTianmi,
    '/share-second-286': ShareTianmi,
    '/share-second-287': ShareTianmi,
    '/share-second-288': ShareTianmi,
    '/share-second-289': ShareTianmi,
    '/share-second-290': ShareTianmi,

    '/share-second-291': ShareTianmi,
    '/share-second-292': ShareTianmi,
    '/share-second-293': ShareTianmi,
    '/share-second-294': ShareTianmi,
    '/share-second-295': ShareTianmi,
    '/share-second-296': ShareTianmi,
    '/share-second-297': ShareTianmi,
    '/share-second-298': ShareTianmi,
    '/share-second-299': ShareTianmi,
    '/share-second-300': ShareTianmi,

    // '/share-admin-1': ShareTianmi,
    // '/share-admin-1': ShareTianmi,
    // '/share-admin-1': ShareTianmi,
    // '/share-admin-1': ShareTianmi,
    // '/share-admin-1': ShareTianmi,
    // '/share-admin-1': ShareTianmi,
    // '/share-admin-1': ShareTianmi,
    // '/share-admin-1': ShareTianmi,
    // '/share-admin-1': ShareTianmi,
    // '/share-admin-1': ShareTianmi,
};


export default router;